import EventTypeFilters from './EventTypeFilters.component';

export default EventTypeFilters;
